import { Suspense } from 'react';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import { LinearProgress } from '@mui/material';
import * as Sentry from '@sentry/react';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import NestedRoute from './NestedRoute';
import { history } from '../helpers';
import { Roles } from '../constants';
import Dashboard from '../pages/dashboard/Dashboard';
import NotFound from '../pages/NotFound';
import { treatmentPlanRoutes } from './treatmentPlanRoutes';
import { adminRoutes } from './adminRoutes';
import { sessionRoutes } from './sessionRoutes';
import { supervisionRoutes } from './supervisionRoutes';
import { billingRoutes } from './billingRoutes';
import { singleRoutes } from './singleRoutes';
import { questionnaireRoutes } from './questionnaireRoutes';

const routes: any = [
  {
    path: '*',
    type: 'public',
    elem: <NotFound />,
    roles: [],
  },
  {
    path: '/',
    type: 'private',
    elem: <Dashboard />,
    roles: [
      Roles.Prbt,
      Roles.Admin,
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.OnboardingCoordinator,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.QaSpecialist,
      Roles.Biller,
      Roles.Guardian,
      Roles.Vbt,
      Roles.LimitedAccessGuardian,
    ],
  },
  {
    path: '/dashboard',
    type: 'private',
    elem: <Dashboard />,
    roles: [
      Roles.Prbt,
      Roles.Admin,
      Roles.Bcba,
      Roles.AssistantAssessor,
      Roles.ClientSuccessManager,
      Roles.Biller,
      Roles.Guardian,
      Roles.Vbt,
      Roles.LimitedAccessGuardian,
      Roles.QaSpecialist,
    ],
  },
  ...sessionRoutes,
  ...supervisionRoutes,
  ...treatmentPlanRoutes,
  ...singleRoutes,
  ...adminRoutes,
  ...billingRoutes,
  ...questionnaireRoutes,
];

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const CustomRouter = () => {
  // init custom history object to allow navigation from
  // anywhere in the react app (inside or outside components)
  history.navigate = useNavigate();
  history.location = useLocation();

  return (
    <Suspense fallback={<LinearProgress />}>
      <SentryRoutes>
        {routes.map((route: any, i: number) => {
          if (route.type === 'private') {
            return (
              <Route
                key={i}
                path={route.path}
                element={
                  <PrivateRoute
                    roles={route.roles}
                    hideForPreClinicalGuardian={route.hideForPreClinicalGuardian}
                  >
                    {route.elem}
                  </PrivateRoute>
                }
              >
                {route.nestedRoutes &&
                  route.nestedRoutes.map((subRoute: any, j: number) => (
                    <Route
                      key={j}
                      path={subRoute.path}
                      element={<NestedRoute>{subRoute.elem}</NestedRoute>}
                    />
                  ))}
              </Route>
            );
          } else if (route.type === 'redirect') {
            if (route?.oldPath && route?.newPath && window.location.href.includes(route?.oldPath)) {
              window.location.replace(window.location.href.replace(route?.oldPath, route?.newPath));
            }
          } else {
            return (
              <Route key={i} path={route.path} element={<PublicRoute>{route.elem}</PublicRoute>} />
            );
          }
        })}
      </SentryRoutes>
    </Suspense>
  );
};

export default CustomRouter;
